import React from 'react'
import logo from './logo.png'
import {Segment, Dimmer, Loader, Message} from 'semantic-ui-react'
import {createAPIClient} from '../../services/api'

export default class ConfirmEmail extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      success: false,
      error: undefined
    }
  }
  componentDidMount() {
    const {router} = this.props
    const confirmemail = router.location.query && router.location.query.confirmemail
    const id = router.location.query && router.location.query.id
    const api = createAPIClient()
    console.log(confirmemail)
    const form = {id: id, token: confirmemail}
    api.put('/auth/signup/confirmemail', form)
      .then(results => {
        this.setState({
          success: true,
          error: undefined}
        )

      })
      .catch(error => {
        this.setState({
          isLoading: false,
          success: false,
          error: 'Something went wrong'
        })
      })
  }
  render () {
    return (
      <div>
        <Dimmer active={this.state.isLoading}>
          <Loader />
        </Dimmer>
        <img style={{'display': 'block', 'maxWidth': '60%', 'margin': '2em auto'}} src={logo} alt='Factoripad' />
        {this.state.success ? (<Message
          success
          header='Your user registration was successful'>
          <p>Email confirmed. To log in please go <a href='/auth/'>Login</a></p>
        </Message>) : undefined}
        {this.state.error ? (<Message
          error
          header='Your user registration was successful'
          content={this.state.error}
        />) : undefined}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/confirmemail/index.js